import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SubscriptionPlan from './SubscriptionPlan';

const PlanDemand: FC = () => {
	const { t } = useTranslation();
	return (
		<div>
			<Typography component="h1" variant="h6">
				{t('taskPlanDemandText')}
			</Typography>
			<SubscriptionPlan />
		</div>
	);
};

export default PlanDemand;
